<div class="wrapper">
  <div class="outer-panel">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
